export const NEAR_DISTANCE = 1000;
export const KM_UNIT = 1000;

export const EXCEPT_BUILDING = ["TG_0008094", "BD_0010004"];

export type BuildingIdType = string;

export type BuildingId = {
  buildingId: BuildingIdType;
};
